import { vaultDisplayInfoList } from 'utils/vaultDisplayInfo'
import { Direction, SortBy, SortConfig, VaultListRow } from '../types'

export const getSortedVaults = (
  displayVaults: VaultListRow[],
  sortableItems: VaultListRow[],
  sortConfig: SortConfig
) => {
  switch (sortConfig.key) {
    case SortBy.Vault:
      // Get initial hardcoded order
      // eslint-disable-next-line no-case-declarations
      const newItems = []
      for (const v of vaultDisplayInfoList) {
        const foundItem = displayVaults.find(i => i.tSymbol === v.tSymbol)
        if (foundItem) {
          newItems.push(foundItem)
        }
      }
      return newItems
    case SortBy.TvlUsd:
      return sortableItems.sort((a, b) =>
        sortConfig.direction === Direction.Descending
          ? (b.tvlUsd ?? 0) - (a.tvlUsd ?? 0)
          : (a.tvlUsd ?? 0) - (b.tvlUsd ?? 0)
      )
    case SortBy.Apy:
      return sortableItems.sort((a, b) =>
        sortConfig.direction === Direction.Descending
          ? (b.apy ?? 0) - (a.apy ?? 0)
          : (a.apy ?? 0) - (b.apy ?? 0)
      )
    case SortBy.DepositedUsd:
      return sortableItems.sort((a, b) =>
        sortConfig.direction === Direction.Descending
          ? (b.depositedUsd ?? 0) - (a.depositedUsd ?? 0)
          : (a.depositedUsd ?? 0) - (b.depositedUsd ?? 0)
      )
    case SortBy.EarnedUsd:
      return sortableItems.sort((a, b) =>
        sortConfig.direction === Direction.Descending
          ? (b.earnedUsd ?? 0) - (a.earnedUsd ?? 0)
          : (a.earnedUsd ?? 0) - (b.earnedUsd ?? 0)
      )
    default:
      return displayVaults
  }
}
